<p-fieldset legend="Pagamento">
    <lib-licitacao-audesp-pagamento-array [entidade]="arquivo" [ajuste]="ajuste"></lib-licitacao-audesp-pagamento-array>
</p-fieldset>